<script setup lang="ts">
import rvapi from "@/rvapi";
import { ref } from "vue";
const loading = ref(false);
const errorMessage = ref("");
const message = ref(`{
  "type": "exception",
  "stack": "Proxy.newCardFromComposition@https://riktigavykort.postnord.se/assets/index.6d3e827b.js:1:97708",
  "errorHash": "ba18f32b1efe3ee8efd2c76da6704089",
  "value": "Cannot read properties of undefined (reading 'format')",
  "exceptionType": "TypeError",
  "deviceId": "00000000-0000-4000-000-000000000000",
  "deviceOs": "Mac",
  "browserName": "Chrome",
  "browserVersion": "115",
  "browserLanguage": "en-US",
  "browserMobile": false,
  "userAgent": "Mozilla/5.0 (Macintosh; Intel) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/115",
  "buildId": "2554",
  "pagehash": "",
  "host": "riktigavykort.postnord.se",
  "path": "/sv/create/preview",
  "query": ""
}`);
const output = ref("output");
const go = async () => {
  loading.value = true;
  errorMessage.value = "";
  output.value = "";
  try {
    const result = await rvapi.getStacktrace(JSON.parse(message.value));
    output.value = result;
  } catch (e: any) {
    output.value = "";
    const data = [
      e.message,
      e?.response?.data?.errorCode,
      e?.response?.data?.errorMessage,
    ];

    errorMessage.value = data.join("\n");
  }
  loading.value = false;
};
</script>

<template>
  <h1>Stacktrace</h1>
  <p><textarea v-model="message" placeholder="input"></textarea></p>
  <p><button @click="go">Go!</button><pn-spinner v-show="loading" /></p>
  <pn-toast
    v-show="errorMessage"
    closable="false"
    appearance="error"
    :text="errorMessage"
  >
  </pn-toast>
  <pre>{{ output }}</pre>
</template>
<style lang="scss" scoped>
textarea {
  width: 600px;
  height: 500px;
}
</style>
